import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react';

export default function GenderIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 16.5a6.75 6.75 0 1 0 0 -13.5 6.75 6.75 0 0 0 0 13.5Zm0 0v5.25" stroke="currentColor"
        strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
      />
    </BaseIcon>
  );
}
